import { render, staticRenderFns } from "./LandingSiteCompanies.vue?vue&type=template&id=62cb9426&scoped=true&"
import script from "./LandingSiteCompanies.vue?vue&type=script&lang=ts&"
export * from "./LandingSiteCompanies.vue?vue&type=script&lang=ts&"
import style0 from "./LandingSiteCompanies.vue?vue&type=style&index=0&id=62cb9426&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cb9426",
  null
  
)

/* custom blocks */
import block0 from "./LandingSiteCompanies.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports